import React, { useEffect } from 'react';
import { NoSsr } from '@mui/material';
import {
  LayoutElementState,
  useLayoutContext,
} from '../../context/LayoutContext';
import useBreakpointStatus from '../../hooks/useBreakpointStatus';
import InlineLeftRail from './InlineLeftRail';
import LayeredLeftRail from './LayeredLeftRail';

export const BREAKPOINT_FOR_LEFT_RAIL_COVER = 'xs';
export const LEFT_RAIL_WIDTH_HIDDEN = 0;
export const LEFT_RAIL_WIDTH_COLLAPSED = 64;
export const LEFT_RAIL_WIDTH = 248;

export interface LeftRailProps {
  children?: React.ReactNode;
}

/**
 * @description A layout component for the left rail which can be toggled open or closed.
 *            If the screen is at or below xs, the left rail will layer ontop of the main content.
 */
export default function LeftRail({ children }: LeftRailProps) {
  const { setLeftRailVisibility, isLeftRailHidden } = useLayoutContext();

  useEffect(() => {
    if (!children && !isLeftRailHidden) {
      setLeftRailVisibility(LayoutElementState.HIDDEN);
    }
  }, [isLeftRailHidden, setLeftRailVisibility, children]);

  const bpStatus = useBreakpointStatus({
    breakpointToCover: BREAKPOINT_FOR_LEFT_RAIL_COVER,
  });
  const Wrapper =
    bpStatus && (bpStatus.isAtBreakpoint || bpStatus.isBelowBreakpoint)
      ? LayeredLeftRail
      : InlineLeftRail;

  return !isLeftRailHidden ? (
    <NoSsr>
      <Wrapper>{children}</Wrapper>
    </NoSsr>
  ) : null;
}
